import { StateCreator, create } from 'zustand';
import { devtools } from 'zustand/middleware';

type TypeChangePasswordModalSlice = {
  changePasswordModal: TypeChangePasswordModal;
  actions: {
    setChangePasswordModal: (changePasswordModal: TypeChangePasswordModal) => void;
    resetChangePasswordModal: () => void;
  };
};

/** @description 비밀번호 변경 모달에 사용되는 state의 형태 */
type TypeChangePasswordModal = {
  /** 렌더링 여부 */
  open: boolean;
  /** 모달 타입 */
  type?: 'initPassword' | 'over90Days';
  /** 모달 메세지 */
  message?: string;
  /** 모달 체크 여부 */
  isChecked?: boolean;
  /** 다음에 변경하기 버튼 클릭 시 실행될 콜백함수 */
  onNextTime?: () => void;
};

const changePasswordModalSlice: StateCreator<TypeChangePasswordModalSlice> = (set) => ({
  changePasswordModal: {
    open: false,
    type: 'initPassword',
    message: '',
    isChecked: false,
    onNextTime: undefined,
  },
  actions: {
    setChangePasswordModal: (changePasswordModal) =>
      set((state) => ({ changePasswordModal: { ...state.changePasswordModal, ...changePasswordModal } })),
    resetChangePasswordModal: () =>
      set(() => ({
        changePasswordModal: {
          open: false,
          type: 'initPassword',
          message: '',
          isChecked: false,
          onNextTime: undefined,
        },
      })),
  },
});

type TypeShouldCheckModalStore = TypeChangePasswordModalSlice;

/** @description 사용자가 앱 실행 최초 1회 반드시 확인해야 하는 모달 상태 */
export const useShouldCheckModalStore = create<TypeShouldCheckModalStore>()(
  devtools(
    (...a) => ({
      ...changePasswordModalSlice(...a),
      actions: {
        ...changePasswordModalSlice(...a).actions,
      },
    }),
    { name: 'shouldCheckModalStore' }
  )
);
